$ = jQuery.noConflict();

$(document).ready(function(){
	if ( $('.isometric-cards').length ) {
		$('.isometric-cards').each(function(){
			const positioner = $(this).find('.isometric-cards__cards-wrapper-scene-pos');
			
			let offsetX = '';
			let offsetY = '';
			const proxy = {
				offsetX: 8,
				offsetY: 3
			};
			
			const friction = 1 / 64;
			const transformerX = gsap.quickSetter(positioner, 'rotateX', 'deg');
			const transformerY = gsap.quickSetter(positioner, 'rotateY', 'deg');
			
			$(window).on('mousemove', function(e){
				let followX = (window.innerWidth / 2 - e.clientX);
				let followY = (window.innerHeight / 2 - e.clientY);
			
				let x = 8,
						y = 3;
						x += ( (-followX - x) * friction);
						y += (followY - y) * friction;
			
			
						gsap.to(proxy, {
							offsetX: x,
							offsetY: y,
							duration: 2.8,
							ease: 'back.out(1.7)'
						});
			
			});
			
			const draw = gsap.timeline({
				repeat: -1,
				onUpdate: function(){
					transformerX(proxy.offsetY);
					transformerY(proxy.offsetX);
				}
			});
			
			draw.to(positioner, {
				y: '-=2%',
				duration: 3,
				ease: 'power3.inOut'
			});
			
			draw.to(positioner, {
				y: '+=2%',
				duration: 6,
				ease: 'power3.inOut'
			});
			
			const boxes = $('.isometric-cards__boxes-list-item');
			if ( boxes.length ) {
				const numBoxes = boxes.length;
				gsap.set(boxes, {
					opacity: 0,
					y: 16
				});
				
				ScrollTrigger.create({
					trigger: $(this).find('.isometric-cards__boxes-list'),
					start: 'top bottom',
					end: 'bottom top',
					onEnter: function() {
						gsap.to(boxes, {
							y: 0,
							opacity: 1,
							stagger: {
								each: 0.15,
								grid: [1, numBoxes]
							}
						});
					},
					onLeave: function() {
						gsap.set(boxes, {
							y: -16,
							opacity:  0
						})
					},
					onEnterBack: function() {
						gsap.to(boxes, {
							y: 0,
							opacity: 1,
							stagger: {
								each: 0.15,
								grid: [1, numBoxes],
								from: 'end'
							}
						});
					},
					onLeaveBack: function() {
						gsap.set(boxes, {
							y: 16,
							opacity:  0
						})
					}
				});
			}
		});
	}
});